export default "__VITE_ASSET__DvOEQOpU__"